webpackJsonp([162898551421021],{

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFoundPage = function (_React$Component) {
	  _inherits(NotFoundPage, _React$Component);
	
	  function NotFoundPage() {
	    _classCallCheck(this, NotFoundPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  NotFoundPage.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      window.dataLayer = window.dataLayer || [];
	      window.dataLayer.push({ event: 'page_not_found', path: location.pathname });
	    }
	  };
	
	  NotFoundPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: { height: 'calc(100vh - 64px)', minHeight: '100%', padding: '1.5rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } },
	      _react2.default.createElement(
	        'h1',
	        { style: { minWidth: '100%', maxWidth: '100%', fontSize: '20vw', lineHeight: '20vw', textAlign: 'center', margin: '0' } },
	        '404'
	      ),
	      _react2.default.createElement(
	        'h1',
	        { style: { minWidth: '100%', maxWidth: '100%', fontSize: '6vw', lineHeight: '4vw', textAlign: 'center', textTransform: 'uppercase', margin: '0' } },
	        'Page not found'
	      ),
	      _react2.default.createElement(
	        'h5',
	        { style: { minWidth: '100%', maxWidth: '100%', fontSize: '3vw', lineHeight: '3vw', textAlign: 'center', marginTop: '6vw' } },
	        'Oops! We can\'t seem to find the page you\'re looking for...'
	      )
	    );
	  };
	
	  return NotFoundPage;
	}(_react2.default.Component);
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-beb4a748ff084ec37e31.js